import { API } from '@/api';
//import axios from 'axios';

const state = {
};
const getters = {

};
const actions = {
   async notifyFirmante({commit, State},{clienteId, documentoId, firmanteId}) {
    const response = await API.get(`/doc/${clienteId}/${documentoId}/${firmanteId}/notificarFirmante`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async notifyDocFirmante({commit, State},{clienteId, documentId}) {
    const response = await API.get(`/doc/${clienteId}/${documentId}/notificarDocFirmado`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
};
const mutations = {
  
};

export default {
  actions,
  mutations,
  getters,
  state,
};
